export default "/images/c42395de19e777d18301a7577b261011.avif";